exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n}\n.center{\n    padding-top: 10px;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/lgh/Documents/apps/editorial/src/app/nosotros/nosotros.component.css
// module id = ../../../../../src/app/nosotros/nosotros.component.css
// module chunks = main